var QRCode = require("qrcode");
var JsBarcode = require('jsbarcode');

export default class QRcode {
  qrBuild = async (text) => {
    return await QRCode.toDataURL(text);
    // .then((res) => {
    //   return res;
    // })
    // .catch((err) => {
    //   return err;
    // });
  };
  barBuild = async (text) => {
    var canvas = document.createElement("canvas");
    await JsBarcode(canvas, text, { format: "CODE39" });
    return canvas.toDataURL("image/png");

  };
}
